import React from "react";
import { FaLock } from "react-icons/fa";

function CodeViewSamplePage() {
  return (
    <div
      className="w-100 d-flex flex-column align-items-center justify-content-center text-center px-3"
      style={{
        flex: 1,
        width: "100%",
        height: "100%",
        minHeight: 0,
        overflow: "hidden",
        backgroundColor: "var(--color-bg-secondary, #f6f8fa)",
      }}
    >
      <FaLock
        size={56}
        color="#c3c6cc"
        style={{ marginBottom: 13 }}
        aria-hidden="true"
      />
      <h2
        style={{
          color: "#1f2328",
          fontSize: 18,
          fontWeight: 600,
          marginBottom: 8,
        }}
      >
        You cannot view the code
      </h2>
      <p
        style={{
          color: "#696f76",
          fontSize: 13,
          maxWidth: 360,
          lineHeight: 1.5,
          marginBottom: 0,
        }}
      >
        You need permission to view this project&apos;s source. Ask the project
        owner to grant you code access.
      </p>
    </div>
  );
}

export default CodeViewSamplePage;
